import ConnectionStatusTemplate from './connection-status.html';
import './connection-status.scss';

let ConnectionStatusDirective = ['$window', '$timeout', '$rootScope', ($window, $timeout, $rootScope) => {
  return {
    	restrict: 'E',
        templateUrl: 'connection-status.html',
    	link: function (scope, element, attrs, controller) {
            let clearMessage = null;

            const initListeners = () => {
                $rootScope.$on('ServerError', () => {
                    $timeout(() => scope.connectionStatus = 'offline');
                })

                $window.addEventListener("offline", function () {
                    $timeout(() => scope.connectionStatus = 'offline');
                }, false)

                $window.addEventListener("online", function () {
                    $timeout(() => {
                        scope.connectionStatus = 'online';
                        scope.startClearTimer();
                    })
                })
            }

            scope.startClearTimer = () => {
                clearMessage = $timeout(() => {
                    scope.connectionStatus = '';
                }, 3000)
            }

            scope.cancelClearTimer = () => {
                if(clearMessage) {
                    $timeout.cancel(clearMessage);
                }
            }

            scope.refresh = () => {
                $window.location.reload();
            }

            initListeners();
        }
  	};
}];

export default ConnectionStatusDirective;



// WEBPACK FOOTER //
// ./client/app/common/connection-status/connection-status.directive.js